import { NotificationDtoKeysEnum } from '@zaoblako/shared/modules/notification/enums/notification-dto-keys.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';

import * as yup from 'yup';

/** Reminder create or update request body */
export interface ReminderFormInterface {
  /** Deal shipping date and time */
  date: Date;
}

/** Reminder create or update request body - DTO schema */
export const ReminderFormDto = SerdeDtoClass.create<ReminderFormInterface>(NotificationDtoKeysEnum.REMINDER_FORM_DTO, {
  date: {
    label: 'Дата',
    serializer: yup.date(),
  },
});
